import { DatePicker, Form } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import moment, { Moment } from 'moment';
import { RangeValue } from 'rc-picker/lib/interface';
import { handleDatePickerChange } from '../../utils/date-picker-helpers';

const { RangePicker } = DatePicker;

interface Props {
    onChange: (values: RadioChangeEvent) => void;
    updateParams: (dates: RangeValue<Moment>) => void;
    startDate: string | undefined;
    endDate: string | undefined;
}

export const GameDatesPicker = (props: Props) => {
    return (
        <Form>
            <Form.Item label="Period" colon={false}>
                <RangePicker
                    allowEmpty={[true, true]}
                    placeholder={['Start at', 'End at']}
                    defaultValue={[
                        props.startDate ? moment(props.startDate) : null,
                        props.endDate ? moment(props.endDate) : null,
                    ]}
                    value={[
                        props.startDate ? moment(props.startDate) : null,
                        props.endDate ? moment(props.endDate) : null,
                    ]}
                    onChange={(dates: RangeValue<moment.Moment>) => {
                        handleDatePickerChange(dates, props.updateParams, () =>
                            props.updateParams(null)
                        );
                    }}
                    format="YYYY-MM-DD"
                />
            </Form.Item>
        </Form>
    );
};
